import type { ReactNode } from 'react';

import { useMediaQuery } from '@react-hookz/web';

import { Typography } from 'src/app/components/Elements/Typography';
import { getStarted } from 'src/app/router/paths';
import { getCurrentPathname } from 'src/app/state/selectors';
import { useSelector } from 'src/app/state/store';
import { theme } from 'src/styles/theme';

import { Container, FormContainer, LargeSubtitle } from '../styles';

import { StepCount } from './StepCount';

interface StepProps {
  children: ReactNode;
  customHandlePrevText?: string;
  customStepCount?: ReactNode;
  handlePrev?: () => void;
  hideHeader?: boolean;
  hideCount?: boolean;
  showCountDesktop?: boolean;
  text?: ReactNode;
  title?: ReactNode;
  showPreviousButton?: boolean;
}

export const Step = ({
  children,
  customHandlePrevText,
  customStepCount,
  handlePrev,
  hideHeader,
  showCountDesktop,
  text,
  title,
  showPreviousButton,
}: StepProps) => {
  const pathname = useSelector(getCurrentPathname);
  const isMobile = useMediaQuery(theme.breakpoints.mediumDown);

  const hasGraySubtitle = pathname === getStarted.toPath();

  return (
    <Container>
      {!hideHeader && (
        <StepCount
          handlePrev={handlePrev}
          customHandlePrevText={customHandlePrevText}
          hideCount={true}
          showCountDesktop={showCountDesktop}
          customStepCount={customStepCount}
          showPreviousButton={showPreviousButton}
        />
      )}
      {title && (
        <>
          {isMobile ? (
            <Typography variant="h2" marginBottom={'s3'}>
              {title}
            </Typography>
          ) : (
            <Typography variant="displayXL" marginBottom={'s5'}>
              {title}
            </Typography>
          )}
        </>
      )}
      {text && (
        <>
          {!hasGraySubtitle && <Typography variant="body">{text}</Typography>}

          {hasGraySubtitle && (
            <Typography variant="body">
              <LargeSubtitle>{text}</LargeSubtitle>
            </Typography>
          )}
        </>
      )}
      <FormContainer>{children}</FormContainer>
    </Container>
  );
};
